import { render, staticRenderFns } from "./DnsNSMapPanel.vue?vue&type=template&id=055b375d&scoped=true&"
import script from "./DnsNSMapPanel.vue?vue&type=script&lang=ts&"
export * from "./DnsNSMapPanel.vue?vue&type=script&lang=ts&"
import style0 from "./DnsNSMapPanel.vue?vue&type=style&index=0&id=055b375d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055b375d",
  null
  
)

export default component.exports